export default __webpack_public_path__ + "static/media/notFound.3ebc6092.svg";